import type { SVGProps } from "react";

interface SortArrowsProps extends Omit<SVGProps<SVGSVGElement>, "order"> {
  order?: "asc" | "desc" | false;
}

const SortArrows = ({ order, className, ...props }: SortArrowsProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={6}
    height={12}
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
    {...props}
  >
    <path
      d="M3 12 0 9l.967-.966L3 10.067l2.033-2.033L6 9l-3 3Z"
      fill="currentColor"
      className={order === "desc" ? "text-pink-500" : "text-gray-500"}
    />
    <path
      d="M.967 4.034 0 3.067l3-3 3 3-.967.967L3 2 .967 4.034Z"
      fill="currentColor"
      className={order === "asc" ? "text-pink-500" : "text-gray-500"}
    />
  </svg>
);

export default SortArrows;
